import DataTable from "datatables.net-react";
import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { CashLedgerLogServices } from "../../services/CashLedgerLogServices";
import * as BullCache from "../../util/BullCache";

function Cashledgerlog(){

  const [Client, setclient] = useState([]);


  var user = BullCache.getFromCache("user");
  useEffect(() => {
   
    CashLedgerLogServices.getusers({ 'adminId': user.adminId }).then(res => {

      if (res.code === 1) {

        if (res.data.userList.length > 0) {
          setclient(res.data.userList);
        }
      }


    });

  }, []);


    return(
        <div className="container-fluid">    
        <Card className="mt-2">
          <Card.Body>
              <Row>
                
                <Col>
                <b className="fss-05">FROM DATE</b>
                    <input type="date" name="bday" />
                </Col>

                <Col>
                <b className="fss-05"> TO DATE</b>
                    <input type="date" name="bday" />
                </Col>

                <Col>
                <b className="fss-05">CLIENT</b>
                            <Form.Select aria-label="Default select example" size='sm' className='bg-light text-black fss-05'>
                            {Client.map((item) => (
                  <option key={item.adminId} value={item.userName}>{item.firstName + ' (' + (item.userName) + ')'}
                  </option>
                ))}
                            </Form.Select>
                </Col>

                <Col className="mt-4">
                   <Button variant="secondary" size="sm" className="w-auto">
                      SEARCH
                   </Button>
                </Col>
                <Col></Col>
                <Col></Col>
                <Col></Col>
                <Col></Col>
              </Row>
          </Card.Body>
        </Card>

        <Card className="mt-2">
          <Card.Body>
          <div className="table-responsive">
              <DataTable className=' striped bordered'>
                      <thead>
                        <tr>
                          <th className='bg-secondary fss-05' >CLIENT</th>
                          <th className='bg-secondary fss-05' >OLD AMOUNT</th>
                          <th className='bg-secondary fss-05' >NEW AMOUNT</th>
                          <th className='bg-secondary fss-05' >OLD REMARK</th>
                          <th className='bg-secondary fss-05' >NEW REMARK</th>
                          <th className='bg-secondary fss-05' >LOG TYPE</th>
                          <th className='bg-secondary fss-05' >IP</th>
                          <th className='bg-secondary fss-05' >EDIT TIME</th>
                          <th className='bg-secondary fss-05' >ADD TIME</th>
                        </tr>
                      </thead>
                     
                    </DataTable>
                    </div>
            </Card.Body>
        </Card>
   </div>
    )
}
export default Cashledgerlog